import { message } from "antd";
import React, { createContext } from "react";

export const MessageContext = createContext();

export const MessageProvider = ({ children }) => {
  const [messageApi, contextHolder] = message.useMessage();

  return (
    <MessageContext.Provider
      value={{
        messageApi,
      }}
    >
      {contextHolder}
      {children}
    </MessageContext.Provider>
  );
};
